__turbopack_context__.v({
  "icon": "AcfStripe-module-scss-module__EMjKVa__icon",
  "icon-and-text-container": "AcfStripe-module-scss-module__EMjKVa__icon-and-text-container",
  "icon-container": "AcfStripe-module-scss-module__EMjKVa__icon-container",
  "stripe": "AcfStripe-module-scss-module__EMjKVa__stripe",
  "stripe-container": "AcfStripe-module-scss-module__EMjKVa__stripe-container",
  "text": "AcfStripe-module-scss-module__EMjKVa__text",
});
